import autosize from "autosize";

export const initConversationCannedResponse = () => {
  const conversation = document.getElementById("conversation") as HTMLDivElement;

  if (!conversation) {
    return;
  }

  const cannedResponses: NodeListOf<HTMLButtonElement> = conversation.querySelectorAll(
    ".canned-responses button",
  );

  if (!cannedResponses) {
    return;
  }

  const submitMessageForm = document.getElementById("submit-message-form") as HTMLFormElement;

  cannedResponses.forEach((cannedResponse) => {
    cannedResponse.addEventListener("click", () => {
      const textarea = submitMessageForm.querySelector("textarea") as HTMLTextAreaElement;

      textarea.value = cannedResponse.dataset.content ? cannedResponse.dataset.content : "";

      autosize(textarea);

      cannedResponses.forEach((cannedResponse) => {
        cannedResponse.classList.remove("active");
      });

      cannedResponse.classList.add("active");
    });
  });
};
